import { Box, Button, Typography, styled } from "@mui/material"
import axios from "axios"
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"
import { addCart, addProduct, updateCartItemCount } from "../../redux/actions/cartActions";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';


const CommonStyleTitle = styled(Typography)(({ theme }) => ({
    fontFamily: theme.palette.typography.fontFamily1,
    textTransform: 'uppercase',
    letterSpacing: '3.5px',
    fontSize: '14px',
    color: '#fff'
}))

export const CommonTitle = ({ text, margin, color, lineHeight, hovercolor }) => {
    return <CommonStyleTitle sx={{ margin: margin, color: color, lineHeight: lineHeight, '&:hover': { color: hovercolor } }}>{text}</CommonStyleTitle>
}

const CommonStyleHeading = styled(Typography)(({ theme }) => ({
    fontFamily: theme.palette.typography.fontFamily1,
    lineHeight: '1.2',
    color: '#fff'
}))

export const CommonHeading = ({ text, margin, color, fontSize, fontWeight, marginBottom }) => {
    return <CommonStyleHeading sx={{ margin: margin, color: color, fontSize: fontSize ? fontSize : { sm: '46px', xs: '30px' }, fontWeight: fontWeight ? fontWeight : 500, marginBottom: marginBottom }}>{text}</CommonStyleHeading>
}

const CommonStyleBox = styled(Box)(({ theme }) => ({
    padding: { xs: '18px', sm: '22px', md: '32px', lg: '42px' },
}))

export const CommonBox = ({ text, borderLeft }) => {
    return <CommonStyleBox sx={{ borderLeft: borderLeft }}>{text}</CommonStyleBox>
}


const CommonDesignBtn = styled(Button)(({ theme }) => ({
    position: 'relative',
    overflow: 'hidden',
    textTransform: 'uppercase',
    border: '1px solid #BB9D7B',
    borderRadius: '0',
    color: '#fff',
    padding: '10px 30px',
    zIndex: 1,
    width: '100%',
    transition: 'all 0.3s linear 0s',
    fontFamily: theme.palette.typography.fontFamily1,
    color: '#BB9D7B'
    , '&:hover': {
        backgroundColor: theme.palette.primary.gold,
        color: theme.palette.primary.main
    }
}))

export const DesignBtn = ({ text, width, padding, slug }) => {
  const dispatch = useDispatch();
  const count = useSelector((state) => state.counter);
const handleClick = async () => {
  try {
    if(text != "Add to cart") return;
    
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_APP}/api/GetProductById?slug=${slug}`);
    let cartData = JSON.parse(localStorage.getItem("cartData")) || [];

    let product = response.data;
    let existingProduct = cartData.find(item => item.product[0].unqid === product[0].unqid);

    if (existingProduct) {
      // Only update count
      existingProduct.count += 1;
      
      // Dispatch only count update in Redux (NOT product_card)
      dispatch(updateCartItemCount(existingProduct.product[0].unqid, 'inc')); 
    } else {
      // New product: add to cart
      const newProduct = { product: { ...product }, count: 1 };
      dispatch(addProduct(newProduct));
      dispatch(addCart(count?.product_card + 1));
      cartData.push(newProduct);
      dispatch({ type: 'TOGGLE_CART'});
    }

    localStorage.setItem("cartData", JSON.stringify(cartData));
  } catch (error) {
    console.error('Error fetching products:', error);
  }
};

  return (
    <CommonDesignBtn sx={{ width: width, padding: padding }} onClick={handleClick}>
      {text}
    </CommonDesignBtn>
  );
};

const CommonBlogDesignBtn = styled(Button)(({ theme }) => ({
    position: 'relative',
    overflow: 'hidden',
    textTransform: 'uppercase',
    border: '1px solid #000',
    borderRadius: '0',
    color: '#000',
    padding: '10px 13px',
    zIndex: 1,
    width: '100%',
    transition: 'all 0.3s linear 0s',
    fontFamily: theme.palette.typography.fontFamily1,
    '&::before': {
        content: '""',
        transform: 'translateX(-49%)',
        borderRight: '50px solid transparent',
        borderBottom: '80px solid #BB9D7B',
        position: 'absolute',
        right: 0,
        left: '-150%',
        top: 0,
        bottom: 0,
        color: theme.palette.primary.gold,
        transition: 'all 0.3s linear 0s',
        zIndex: -1
    },
    '&::after': {
        content: '""',
        transform: 'translateX(49%)',
        borderLeft: '50px solid transparent',
        borderTop: '80px solid #BB9D7B',
        position: 'absolute',
        right: '-150%',
        top: 0,
        left: 0,
        bottom: 0,
        color: 'red',
        transition: 'all 0.3s linear 0s',
        zIndex: -1
    },
    '&:hover': {
        ":before": {
            left: '31%',
        },
        ":after": {
            right: '31%',
        },
        color: '#fff',
        border: `1px solid ${theme.palette.primary.gold}`,
    }
}))

export const WhatsAppFloatingButton = () => {
  return (
    <Box
      component="a"
      href="https://wa.me/qr/SV3HEFPLHBAYP1" // 🔁 Replace with your WhatsApp number
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        position: 'fixed',
        bottom: 16,
        right: 16,
        backgroundColor: '#25D366',
        color: 'white',
        borderRadius: '50%',
        width: 60,
        height: 60,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 10000,
        boxShadow: 3,
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: '#20b358',
        },
      }}
    >
      <WhatsAppIcon fontSize="large" />
    </Box>
  );
}

export const BlogDesignBtn = ({ text, width, hoverbordercolor }) => {
    return <CommonBlogDesignBtn sx={{ width: width, border: hoverbordercolor }}>{text}</CommonBlogDesignBtn>
}

